(function () {
  var CART_FIELDS =
    'id checkoutUrl totalQuantity ' +
    'cost { subtotalAmount { amount currencyCode } } ' +
    'lines(first: 100) { edges { node { id quantity merchandise { ... on ProductVariant { id title availableForSale price { amount currencyCode } image { url altText } product { title handle } } } } } }';

  var CART_CREATE = 'mutation CartCreate($lines: [CartLineInput!]) { cartCreate(input: { lines: $lines }) { cart { ' + CART_FIELDS + ' } userErrors { field message } } }';
  var CART_LINES_ADD = 'mutation CartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) { cartLinesAdd(cartId: $cartId, lines: $lines) { cart { ' + CART_FIELDS + ' } userErrors { field message } } }';
  var CART_LINES_UPDATE = 'mutation CartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) { cartLinesUpdate(cartId: $cartId, lines: $lines) { cart { ' + CART_FIELDS + ' } userErrors { field message } } }';
  var CART_LINES_REMOVE = 'mutation CartLinesRemove($cartId: ID!, $lineIds: [ID!]!) { cartLinesRemove(cartId: $cartId, lineIds: $lineIds) { cart { ' + CART_FIELDS + ' } userErrors { field message } } }';
  var CART_QUERY = 'query CartQuery($id: ID!) { cart(id: $id) { ' + CART_FIELDS + ' } }';

  var PRODUCTS_QUERY =
    'query CollectionProducts($id: ID!, $first: Int!) {' +
    '  collection(id: $id) {' +
    '    products(first: $first) {' +
    '      edges {' +
    '        node {' +
    '          title' +
    '          handle' +
    '          availableForSale' +
    '          featuredImage { url altText }' +
    '          priceRange { minVariantPrice { amount currencyCode } }' +
    '          options { name values }' +
    '          variants(first: 25) {' +
    '            edges {' +
    '              node {' +
    '                id' +
    '                title' +
    '                availableForSale' +
    '                selectedOptions { name value }' +
    '                price { amount currencyCode }' +
    '              }' +
    '            }' +
    '          }' +
    '        }' +
    '      }' +
    '    }' +
    '  }' +
    '}';

  var PRODUCT_QUERY =
    'query ProductByHandle($handle: String!) {' +
    '  product(handle: $handle) {' +
    '    title' +
    '    handle' +
    '    descriptionHtml' +
    '    availableForSale' +
    '    images(first: 10) { edges { node { url altText } } }' +
    '    options { name values }' +
    '    variants(first: 25) {' +
    '      edges {' +
    '        node {' +
    '          id' +
    '          title' +
    '          availableForSale' +
    '          selectedOptions { name value }' +
    '          price { amount currencyCode }' +
    '          image { url altText }' +
    '        }' +
    '      }' +
    '    }' +
    '  }' +
    '}';

  function money(amount, currencyCode) {
    var value = Number(amount);
    if (isNaN(value)) return '';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(value);
    } catch (e) {
      return currencyCode + ' ' + value.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  /* ------------------------------------------------------------------
   * Imprint cart controller — one shared cart per Imprint store domain,
   * used by every imprint-collection section instance on the page.
   * ------------------------------------------------------------------ */
  var ImprintCart = {
    config: null,
    cart: null,
    listeners: [],

    init: function (config) {
      if (this.config) return;
      this.config = config;
      this.endpoint = 'https://' + config.storeDomain + '/api/' + config.apiVersion + '/graphql.json';
      this.storageKey = 'windwaker-imprint-cart:' + config.storeDomain;
      this.buildDrawer();
      this.restore();
    },

    request: function (query, variables) {
      var self = this;
      return fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': self.config.storefrontToken
        },
        body: JSON.stringify({ query: query, variables: variables })
      }).then(function (res) {
        return res.json();
      });
    },

    restore: function () {
      var self = this;
      var id = null;
      try {
        id = window.localStorage.getItem(this.storageKey);
      } catch (e) {}
      if (!id) {
        this.render();
        return;
      }
      this.request(CART_QUERY, { id: id }).then(function (json) {
        var cart = json && json.data ? json.data.cart : null;
        if (cart) {
          self.cart = cart;
        } else {
          try {
            window.localStorage.removeItem(self.storageKey);
          } catch (e) {}
        }
        self.render();
      }).catch(function () {
        self.render();
      });
    },

    persist: function (cart) {
      this.cart = cart;
      try {
        window.localStorage.setItem(this.storageKey, cart.id);
      } catch (e) {}
      this.render();
    },

    addLine: function (variantId, quantity) {
      var self = this;
      var line = { merchandiseId: variantId, quantity: quantity || 1 };

      var promise;
      if (this.cart && this.cart.id) {
        promise = this.request(CART_LINES_ADD, { cartId: this.cart.id, lines: [line] }).then(function (json) {
          return json.data.cartLinesAdd;
        });
      } else {
        promise = this.request(CART_CREATE, { lines: [line] }).then(function (json) {
          return json.data.cartCreate;
        });
      }

      return promise.then(function (result) {
        if (result.userErrors && result.userErrors.length) {
          throw new Error(result.userErrors.map(function (e) { return e.message; }).join(', '));
        }
        self.persist(result.cart);
        self.openDrawer();
        return result.cart;
      });
    },

    updateLine: function (lineId, quantity) {
      var self = this;
      if (!this.cart) return Promise.resolve();
      return this.request(CART_LINES_UPDATE, { cartId: this.cart.id, lines: [{ id: lineId, quantity: quantity }] })
        .then(function (json) {
          var result = json.data.cartLinesUpdate;
          self.persist(result.cart);
        });
    },

    removeLine: function (lineId) {
      var self = this;
      if (!this.cart) return Promise.resolve();
      return this.request(CART_LINES_REMOVE, { cartId: this.cart.id, lineIds: [lineId] }).then(function (json) {
        var result = json.data.cartLinesRemove;
        self.persist(result.cart);
      });
    },

    totalQuantity: function () {
      return this.cart ? this.cart.totalQuantity : 0;
    },

    buildDrawer: function () {
      if (document.querySelector('[data-imprint-cart-drawer]')) return;

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'imprint-cart-toggle';
      toggle.setAttribute('data-imprint-cart-toggle', '');
      toggle.innerHTML =
        '<svg class="imprint-cart-toggle__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M6 8V7a6 6 0 1 1 12 0v1h2.29a1 1 0 0 1 1 .92l1 12a1 1 0 0 1-1 1.08H4.71a1 1 0 0 1-1-1.08l1-12a1 1 0 0 1 1-.92H6Zm2 0h8V7a4 4 0 1 0-8 0v1Z" fill="currentColor"/>' +
        '</svg>' +
        '<span>Cart (<span data-imprint-cart-count>0</span>)</span>';
      toggle.addEventListener('click', this.openDrawer.bind(this));

      var drawer = document.createElement('div');
      drawer.className = 'imprint-cart-drawer';
      drawer.setAttribute('data-imprint-cart-drawer', '');
      drawer.innerHTML =
        '<div class="imprint-cart-drawer__overlay" data-imprint-cart-close></div>' +
        '<div class="imprint-cart-drawer__panel">' +
        '<div class="imprint-cart-drawer__header">' +
        '<span>Cart</span>' +
        '<button type="button" class="imprint-cart-drawer__close" data-imprint-cart-close aria-label="Close cart">&times;</button>' +
        '</div>' +
        '<div class="imprint-cart-drawer__lines" data-imprint-cart-lines></div>' +
        '<div class="imprint-cart-drawer__footer">' +
        '<div class="imprint-cart-drawer__subtotal" data-imprint-cart-subtotal></div>' +
        '<a class="button imprint-cart-drawer__checkout" data-imprint-cart-checkout href="#">Checkout</a>' +
        '</div>' +
        '</div>';

      document.body.appendChild(toggle);
      document.body.appendChild(drawer);

      drawer.querySelectorAll('[data-imprint-cart-close]').forEach(function (el) {
        el.addEventListener('click', this.closeDrawer.bind(this));
      }, this);
    },

    openDrawer: function () {
      var drawer = document.querySelector('[data-imprint-cart-drawer]');
      if (drawer) drawer.setAttribute('data-open', 'true');
    },

    closeDrawer: function () {
      var drawer = document.querySelector('[data-imprint-cart-drawer]');
      if (drawer) drawer.removeAttribute('data-open');
    },

    render: function () {
      var count = this.totalQuantity();
      var countEl = document.querySelector('[data-imprint-cart-count]');
      if (countEl) countEl.textContent = count;

      var linesEl = document.querySelector('[data-imprint-cart-lines]');
      var subtotalEl = document.querySelector('[data-imprint-cart-subtotal]');
      var checkoutEl = document.querySelector('[data-imprint-cart-checkout]');
      if (!linesEl) return;

      var cart = this.cart;
      if (!cart || !cart.lines.edges.length) {
        linesEl.innerHTML = '<p class="imprint-cart-drawer__empty">Your cart is empty.</p>';
        if (subtotalEl) subtotalEl.textContent = '';
        if (checkoutEl) checkoutEl.setAttribute('aria-disabled', 'true');
        return;
      }

      if (checkoutEl) {
        checkoutEl.removeAttribute('aria-disabled');
        checkoutEl.setAttribute('href', cart.checkoutUrl);
      }

      var self = this;
      linesEl.innerHTML = cart.lines.edges.map(function (edge) {
        var line = edge.node;
        var variant = line.merchandise;
        var image = variant.image ? variant.image.url : '';
        var lineTotal = money(Number(variant.price.amount) * line.quantity, variant.price.currencyCode);

        return (
          '<div class="imprint-cart-line" data-line-id="' + line.id + '">' +
          (image ? '<img src="' + escapeHtml(image) + '" alt="" width="72" height="72">' : '') +
          '<div class="imprint-cart-line__details">' +
          '<div class="imprint-cart-line__title">' + escapeHtml(variant.product.title) + '</div>' +
          (variant.title !== 'Default Title' ? '<div class="imprint-cart-line__variant">' + escapeHtml(variant.title) + '</div>' : '') +
          '<div class="imprint-cart-line__controls">' +
          '<button type="button" class="imprint-cart-line__qty-btn" data-imprint-cart-decrement>-</button>' +
          '<span>' + line.quantity + '</span>' +
          '<button type="button" class="imprint-cart-line__qty-btn" data-imprint-cart-increment>+</button>' +
          '<button type="button" class="imprint-cart-line__remove" data-imprint-cart-remove>Remove</button>' +
          '</div>' +
          '</div>' +
          '<div class="imprint-cart-line__total">' + lineTotal + '</div>' +
          '</div>'
        );
      }).join('');

      if (subtotalEl) {
        subtotalEl.textContent = 'Subtotal: ' + money(cart.cost.subtotalAmount.amount, cart.cost.subtotalAmount.currencyCode);
      }

      linesEl.querySelectorAll('[data-line-id]').forEach(function (row) {
        var lineId = row.getAttribute('data-line-id');
        var line = cart.lines.edges.map(function (e) { return e.node; }).find(function (n) { return n.id === lineId; });

        var decrement = row.querySelector('[data-imprint-cart-decrement]');
        var increment = row.querySelector('[data-imprint-cart-increment]');
        var remove = row.querySelector('[data-imprint-cart-remove]');

        if (decrement) {
          decrement.addEventListener('click', function () {
            var next = line.quantity - 1;
            if (next <= 0) {
              self.removeLine(lineId);
            } else {
              self.updateLine(lineId, next);
            }
          });
        }
        if (increment) {
          increment.addEventListener('click', function () {
            self.updateLine(lineId, line.quantity + 1);
          });
        }
        if (remove) {
          remove.addEventListener('click', function () {
            self.removeLine(lineId);
          });
        }
      });
    }
  };

  /* ------------------------------------------------------------------
   * Product card rendering
   * ------------------------------------------------------------------ */
  function hasRealOptions(product) {
    return product.options.some(function (opt) {
      return !(opt.name === 'Title' && opt.values.length === 1 && opt.values[0] === 'Default Title');
    });
  }

  function productPageUrl(base, handle) {
    var path = base || window.location.pathname;
    return path + '?imprint_product=' + encodeURIComponent(handle);
  }

  function cardHtml(product, productPageBase) {
    var image = product.featuredImage ? product.featuredImage.url : '';
    var alt = product.featuredImage && product.featuredImage.altText ? product.featuredImage.altText : product.title;
    var price = money(product.priceRange.minVariantPrice.amount, product.priceRange.minVariantPrice.currencyCode);
    var soldOut = !product.availableForSale;
    var url = productPageUrl(productPageBase, product.handle);

    return (
      '<a class="imprint-collection__card" href="' + url + '">' +
      '<div class="imprint-collection__media">' +
      (image
        ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(alt) + '" loading="lazy" width="600" height="600">'
        : '') +
      (soldOut ? '<span class="imprint-collection__badge">Sold out</span>' : '') +
      '</div>' +
      '<div class="imprint-collection__title">' + escapeHtml(product.title) + '</div>' +
      '<div class="imprint-collection__price">' + escapeHtml(price) + '</div>' +
      '</a>'
    );
  }

  /* ------------------------------------------------------------------
   * Product detail view (in-page, own-domain "product page")
   * ------------------------------------------------------------------ */
  function renderProductView(root, config, product, related) {
    var browseView = root.querySelector('[data-imprint-browse-view]');
    var productView = root.querySelector('[data-imprint-product-view]');
    if (browseView) browseView.hidden = true;
    if (!productView) return;
    productView.hidden = false;

    var images = product.images.edges.map(function (e) { return e.node; });
    var variants = product.variants.edges.map(function (e) { return e.node; });
    var showOptions = hasRealOptions(product);
    var backUrl = window.location.pathname;

    var mainImage = images.length ? images[0] : null;

    var thumbnails = images.length > 1
      ? '<div class="imprint-product__thumbnails" data-imprint-thumbnails>' +
        images.map(function (img, i) {
          return (
            '<button type="button" class="imprint-product__thumbnail" data-imprint-thumb data-src="' + escapeHtml(img.url) + '"' +
            (i === 0 ? ' aria-current="true"' : '') + '>' +
            '<img src="' + escapeHtml(img.url) + '" alt="' + escapeHtml(img.altText || product.title) + '" loading="lazy">' +
            '</button>'
          );
        }).join('') +
        '</div>'
      : '';

    var optionsMarkup = '';
    if (showOptions) {
      optionsMarkup = product.options.map(function (option) {
        var values = option.values.map(function (value) {
          var matching = variants.find(function (v) {
            return v.selectedOptions.some(function (o) { return o.name === option.name && o.value === value; });
          });
          var available = matching ? matching.availableForSale : true;
          return (
            '<option value="' + escapeHtml(value) + '"' + (available ? '' : ' disabled') + '>' +
            escapeHtml(value) + (available ? '' : ' (Sold out)') +
            '</option>'
          );
        }).join('');

        return (
          '<div class="imprint-product__option" data-imprint-option data-option-name="' + escapeHtml(option.name) + '">' +
          '<label class="imprint-product__option-label">' + escapeHtml(option.name) + '</label>' +
          '<select class="imprint-product__option-select">' + values + '</select>' +
          '</div>'
        );
      }).join('');
    }

    var defaultVariant = variants.find(function (v) { return v.availableForSale; }) || variants[0];
    var soldOut = !product.availableForSale;

    productView.innerHTML =
      '<a class="imprint-product__back" href="' + backUrl + '">&larr; Back to all products</a>' +
      '<div class="imprint-product__layout">' +
      '<div class="imprint-product__gallery">' +
      '<div class="imprint-product__main-image" data-imprint-main-image>' +
      (mainImage ? '<img src="' + escapeHtml(mainImage.url) + '" alt="' + escapeHtml(mainImage.altText || product.title) + '">' : '') +
      '</div>' +
      thumbnails +
      '</div>' +
      '<div class="imprint-product__info">' +
      '<h1 class="imprint-product__title">' + escapeHtml(product.title) + '</h1>' +
      '<div class="imprint-product__price" data-imprint-product-price>' +
      escapeHtml(defaultVariant ? money(defaultVariant.price.amount, defaultVariant.price.currencyCode) : '') +
      '</div>' +
      optionsMarkup +
      '<div class="imprint-product__quantity">' +
      '<button type="button" data-imprint-qty-decrement>-</button>' +
      '<span data-imprint-qty-value>1</span>' +
      '<button type="button" data-imprint-qty-increment>+</button>' +
      '</div>' +
      '<button type="button" class="button imprint-product__add" data-imprint-product-add ' + (soldOut ? 'disabled' : '') + '>' +
      (soldOut ? 'Sold out' : 'Add to cart') +
      '</button>' +
      '<div class="imprint-product__description">' + (product.descriptionHtml || '') + '</div>' +
      '</div>' +
      '</div>' +
      (related && related.length
        ? '<div class="imprint-product__related">' +
          '<h2 class="imprint-product__related-heading">You may also like</h2>' +
          '<div class="imprint-product__related-grid">' +
          related.map(function (relatedProduct) {
            return cardHtml(relatedProduct, window.location.pathname);
          }).join('') +
          '</div>' +
          '</div>'
        : '');

    var quantity = 1;
    var selectedVariant = defaultVariant;

    function updateVariant() {
      var selected = {};
      productView.querySelectorAll('[data-imprint-option]').forEach(function (optionEl) {
        var name = optionEl.getAttribute('data-option-name');
        var select = optionEl.querySelector('select');
        selected[name] = select.value;
      });

      var match = variants.find(function (v) {
        return v.selectedOptions.every(function (o) { return selected[o.name] === o.value; });
      });

      if (match) {
        selectedVariant = match;
        var priceEl = productView.querySelector('[data-imprint-product-price]');
        if (priceEl) priceEl.textContent = money(match.price.amount, match.price.currencyCode);

        var addBtn = productView.querySelector('[data-imprint-product-add]');
        if (addBtn) {
          addBtn.disabled = !match.availableForSale;
          addBtn.textContent = match.availableForSale ? 'Add to cart' : 'Sold out';
        }

        if (match.image) {
          var mainImageEl = productView.querySelector('[data-imprint-main-image]');
          if (mainImageEl) {
            mainImageEl.innerHTML = '<img src="' + escapeHtml(match.image.url) + '" alt="' + escapeHtml(match.image.altText || product.title) + '">';
          }
          productView.querySelectorAll('[data-imprint-thumb]').forEach(function (t) {
            t.removeAttribute('aria-current');
            if (t.getAttribute('data-src') === match.image.url) {
              t.setAttribute('aria-current', 'true');
            }
          });
        }
      }
    }

    productView.querySelectorAll('[data-imprint-option] select').forEach(function (select) {
      select.addEventListener('change', updateVariant);
    });

    productView.querySelectorAll('[data-imprint-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mainImageEl = productView.querySelector('[data-imprint-main-image]');
        if (mainImageEl) {
          mainImageEl.innerHTML = '<img src="' + thumb.getAttribute('data-src') + '" alt="">';
        }
        productView.querySelectorAll('[data-imprint-thumb]').forEach(function (t) {
          t.removeAttribute('aria-current');
        });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    var qtyValue = productView.querySelector('[data-imprint-qty-value]');
    var decrementBtn = productView.querySelector('[data-imprint-qty-decrement]');
    var incrementBtn = productView.querySelector('[data-imprint-qty-increment]');

    if (decrementBtn) {
      decrementBtn.addEventListener('click', function () {
        if (quantity > 1) {
          quantity -= 1;
          qtyValue.textContent = quantity;
        }
      });
    }
    if (incrementBtn) {
      incrementBtn.addEventListener('click', function () {
        quantity += 1;
        qtyValue.textContent = quantity;
      });
    }

    var addButton = productView.querySelector('[data-imprint-product-add]');
    if (addButton) {
      addButton.addEventListener('click', function () {
        if (!selectedVariant) return;

        addButton.disabled = true;
        var originalText = addButton.textContent;
        addButton.textContent = 'Adding...';

        ImprintCart.addLine(selectedVariant.id, quantity)
          .then(function () {
            addButton.textContent = 'Added';
            setTimeout(function () {
              addButton.textContent = originalText;
              addButton.disabled = false;
            }, 1200);
          })
          .catch(function () {
            addButton.textContent = 'Error, try again';
            setTimeout(function () {
              addButton.textContent = originalText;
              addButton.disabled = false;
            }, 1500);
          });
      });
    }
  }

  async function showProductView(root, config, handle) {
    var endpoint = 'https://' + config.storeDomain + '/api/' + config.apiVersion + '/graphql.json';

    try {
      var response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': config.storefrontToken
        },
        body: JSON.stringify({ query: PRODUCT_QUERY, variables: { handle: handle } })
      });

      var json = await response.json();
      var product = json && json.data ? json.data.product : null;

      if (!product) {
        root.setAttribute('data-imprint-collection-state', 'error');
        return;
      }

      var related = [];
      try {
        var relatedResponse = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': config.storefrontToken
          },
          body: JSON.stringify({
            query: PRODUCTS_QUERY,
            variables: { id: 'gid://shopify/Collection/' + config.collectionId, first: 8 }
          })
        });
        var relatedJson = await relatedResponse.json();
        var relatedEdges = relatedJson && relatedJson.data && relatedJson.data.collection
          ? relatedJson.data.collection.products.edges
          : [];
        related = relatedEdges
          .map(function (edge) { return edge.node; })
          .filter(function (p) { return p.handle !== handle; })
          .slice(0, 4);
      } catch (e) {
        related = [];
      }

      renderProductView(root, config, product, related);
    } catch (e) {
      root.setAttribute('data-imprint-collection-state', 'error');
    }
  }

  async function hydrateGrid(root, config) {
    var grid = root.querySelector('[data-imprint-collection-grid]');
    if (!grid) return;

    var endpoint = 'https://' + config.storeDomain + '/api/' + config.apiVersion + '/graphql.json';

    try {
      var response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': config.storefrontToken
        },
        body: JSON.stringify({
          query: PRODUCTS_QUERY,
          variables: {
            id: 'gid://shopify/Collection/' + config.collectionId,
            first: config.maxProducts
          }
        })
      });

      var json = await response.json();
      var edges = json && json.data && json.data.collection ? json.data.collection.products.edges : [];

      if (!edges.length) {
        root.setAttribute('data-imprint-collection-state', 'empty');
        return;
      }

      var productPageBase = config.productPageLink || window.location.pathname;

      grid.innerHTML = edges.map(function (edge) {
        return cardHtml(edge.node, productPageBase);
      }).join('');
      root.setAttribute('data-imprint-collection-state', 'loaded');
    } catch (e) {
      root.setAttribute('data-imprint-collection-state', 'error');
    }
  }

  function hydrate(root) {
    var configEl = root.querySelector('script[data-imprint-collection-config]');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    ImprintCart.init(config);

    var handle = new URLSearchParams(window.location.search).get('imprint_product');
    if (handle) {
      showProductView(root, config, handle);
      return;
    }

    hydrateGrid(root, config);
  }

  document.querySelectorAll('[data-imprint-collection]').forEach(hydrate);
})();
